export const parseThousandsGroups = (num) => {
  return new Intl.NumberFormat('en-EN', {
    style: 'decimal',
  }).format(parseFloat(num).toFixed(3))
}
